import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing } = themeVariables;

export const root = css`
  overflow: hidden;
  border-radius: var(${spacing.md});
  background-color: color-mix(in srgb, var(${colors.content.link}) 5%, white);
  border: 1px solid color-mix(in srgb, var(${colors.content.link}) 30%, white);

  a {
    color: var(${colors.content.link});
  }
`;

export const topBrandHeader = css`
  display: flex;
  align-items: center;
  padding: var(${spacing.xs}) var(${spacing.sm});
  background-color: #e3f0f7; // there is no color-mix that matches this color
`;

export const content = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
  padding: var(${spacing.md});
`;
